import PhoneShell from '../components/shared/PhoneShell';
import CategoryNav from '../components/home/CategoryNav';
import Banner from '../components/home/Banner';
import TopPicks from '../components/home/TopPicks';
import { BigTiles, SmallTiles } from '../components/home/Tiles';
import LiveNow from '../components/home/LiveNow';
import HomeUpcoming from '../components/home/HomeUpcoming';
import PopularCompetitions from '../components/home/PopularCompetitions';
import MoreSports from '../components/home/MoreSports';
export default function Home() {
  return (
    <PhoneShell activeTab="home">
      <CategoryNav />
      <Banner />
      <TopPicks />
      <BigTiles />
      <SmallTiles />
      <LiveNow />
      <HomeUpcoming />
      <PopularCompetitions />
      <MoreSports />
    </PhoneShell>
  );
}
